/**
 * Blocker Plugin - Handles blocker descriptor launches from Echo
 * Receives blocker launch requests from the desktop Echo app
 */

import { EchoConnection, EchoPlugin } from '../types'

// EchoClient will be imported from data-access when we move it there
interface EchoClientLike {
  emit(event: string, data: unknown): void
}

export interface BlockerPluginOptions {
  /**
   * Callback to handle blocker navigation with payload
   * @param payload - The blocker descriptor JSON string
   */
  onLaunchBlocker?: (payload: string) => void
}

export class BlockerPlugin implements EchoPlugin {
  readonly id = 'com.cash.echo.plugin.blocker'
  private connection: EchoConnection | null = null
  private echoClient: EchoClientLike
  private onLaunchBlockerCallback?: (payload: string) => void

  constructor(echoClient: EchoClientLike, options: BlockerPluginOptions = {}) {
    this.echoClient = echoClient
    this.onLaunchBlockerCallback = options.onLaunchBlocker
  }

  onConnect(connection: EchoConnection): void {
    this.connection = connection
  }

  onDisconnect(): void {
    this.connection = null
  }

  onDesktopPluginActive(): void {
    // Desktop plugin became active
  }

  onDesktopPluginInactive(): void {
    // Desktop plugin became inactive
  }

  onDataReceived(data: string): void {
    try {
      const event = JSON.parse(data)

      // Handle launch-blocker event from desktop
      if (event.name === 'launch-blocker' && event.metadata?.payload) {
        const payload = event.metadata.payload
        this.handleLaunch(payload)
      }
    } catch (error) {
      this.echoClient.emit('error', error as Error)
    }
  }

  /**
   * Set the launch blocker callback
   */
  setOnLaunchBlocker(callback: (payload: string) => void): void {
    this.onLaunchBlockerCallback = callback
  }

  /**
   * Private: Handle blocker launch request
   */
  private handleLaunch(payload: string): void {
    if (this.onLaunchBlockerCallback) {
      this.onLaunchBlockerCallback(payload)
    }
  }
}
